import { render, staticRenderFns } from "./MainLedgerCreate.vue?vue&type=template&id=59cc7451"
import script from "./MainLedgerCreate.vue?vue&type=script&lang=js"
export * from "./MainLedgerCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports